var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFailCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#FA1C44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3418 30.2131C19.3455 29.6773 19.5077 29.1545 19.808 28.7107C20.1084 28.2669 20.5334 27.922 21.0295 27.7195C21.5256 27.5169 22.0706 27.4658 22.5957 27.5725C23.1208 27.6793 23.6026 27.9391 23.9802 28.3193C24.3579 28.6995 24.6144 29.183 24.7176 29.7089C24.8209 30.2347 24.7661 30.7793 24.5602 31.274C24.3543 31.7688 24.0065 32.1914 23.5607 32.4888C23.1149 32.7861 22.591 32.9448 22.0551 32.9448C21.6952 32.9524 21.3375 32.8868 21.0036 32.752C20.6698 32.6171 20.3669 32.4159 20.1132 32.1604C19.8594 31.905 19.6602 31.6007 19.5276 31.266C19.395 30.9312 19.3318 30.573 19.3418 30.2131ZM20.0018 14.9048L19.8552 10.9448H24.2368L24.0902 14.9048L23.4668 25.3915H20.6252L20.0018 14.9048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFailCircle);
export default __webpack_public_path__ + "static/media/ic_fail_circle.a5fdb71f5752bc2c43d55844be6af38b.svg";
export { ForwardRef as ReactComponent };